import comp from "./TextMoreLessV2";
export default comp;
